// extracted by mini-css-extract-plugin
module.exports = {"dimensions__title":"Dimensions_dimensions__title__E8gQ5"};